import React from 'react';
import { FormikValues, useFormik } from 'formik';
import { useMutation, useQueryClient } from 'react-query';

import { ACTION_ERROR_INTER, FORM_VALUE_ENUM } from './constant';
import { Component } from './component';
import { updateData } from './action';
import { USER_LIST_MODULE_NAME } from '../user-list';
import { USER_ROLE } from '../../data/auth/constant';

export const Container: React.FC<{
  userId?: string;
  formData?: {
    role?: number;
    level?: number;
    endBlocking?: string | null;
  };
}> = ({ userId, formData }) => {
  const query = useQueryClient();

  const onSuccess = () => {
    query.invalidateQueries(USER_LIST_MODULE_NAME);
  };

  const action = useMutation(() => updateData(userId, formData), { onSuccess });

  const initialValues = {
    [FORM_VALUE_ENUM.ROLE]: formData?.role,
    [FORM_VALUE_ENUM.LEVEL]: formData?.level,
    [FORM_VALUE_ENUM.DATE]: formData?.endBlocking,
  };

  const formik: FormikValues = useFormik({
    initialValues,
    // enableReinitialize: true,
    onSubmit: () => {
      action.mutate();
    },
  });

  const isSubmitDisabled = () => {
    return action.isLoading;
  };

  const getErrorMessage = () => {
    const error: ACTION_ERROR_INTER = action.error as ACTION_ERROR_INTER;
    if (error) {
      return error.message;
    }
  };

  const isSuccess = () => {
    return action.isSuccess;
  };

  const isError = () => {
    if (action.isError && !action.isLoading && getErrorMessage()) {
      return true;
    }
  };

  return (
    <Component
      isSubmitDisabled={isSubmitDisabled}
      isSuccess={isSuccess()}
      formik={formik}
      isError={isError()}
      errorMessage={getErrorMessage()}
    />
  );
};
